import { useCallback, useRef, useState } from "react";
import { message } from "antd";
import { getUnsortedExpenses, getSortedExpenseHistory, getIgnoredExpenses } from "../api/transactionScheduleApi";

const CACHE_TTL_MS = 30_000;

export default function useExpenseSorting() {
    const [unsortedExpenses, setUnsortedExpenses] = useState([]);
    const [loadingUnsorted, setLoadingUnsorted] = useState(false);

    const [sortedHistory, setSortedHistory] = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(false);

    const [ignoredExpenses, setIgnoredExpenses] = useState([]);
    const [loadingIgnored, setLoadingIgnored] = useState(false);

    const lastFetchedAt = useRef(null);

    const loadUnsortedExpenses = useCallback(async () => {
        setLoadingUnsorted(true);
        try {
            const data = await getUnsortedExpenses();
            const rows = (data || []).map((item) => ({ ...item, key: item.statementId }));
            setUnsortedExpenses(rows);
            return rows;
        } catch (error) {
            message.error(error.message || "Зардлын жагсаалт ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingUnsorted(false);
        }
    }, []);

    const loadSortedHistory = useCallback(async () => {
        setLoadingHistory(true);
        try {
            const data = await getSortedExpenseHistory();
            const rows = (data || []).map((item, i) => ({ ...item, key: item.statementId ?? i }));
            setSortedHistory(rows);
            return rows;
        } catch (error) {
            message.error(error.message || "Ангилсан түүх ачаалж чадсангүй");
            return [];
        } finally {
            setLoadingHistory(false);
        }
    }, []);


    const loadIgnoredExpenses = useCallback(async () => {
        setLoadingIgnored(true);
        try {
            const data = await getIgnoredExpenses();
            setIgnoredExpenses((data || []).map((item, i) => ({ ...item, key: item.statementId ?? i })));
        } catch (error) {
            message.error(error.message || "Үл хамаарах зардлын жагсаалт ачаалж чадсангүй");
        } finally {
            setLoadingIgnored(false);
        }
    }, []);

    // Update refreshExpenseSortingData:
    const refreshExpenseSortingData = useCallback(async (force = false) => {
        if (!force && lastFetchedAt.current && Date.now() - lastFetchedAt.current < CACHE_TTL_MS) return;
        await Promise.all([loadUnsortedExpenses(), loadSortedHistory(), loadIgnoredExpenses()]);
        lastFetchedAt.current = Date.now();
    }, [loadUnsortedExpenses, loadSortedHistory, loadIgnoredExpenses]);

    // Add to return:
    return {
        unsortedExpenses, loadingUnsorted,
        sortedHistory, loadingHistory,
        ignoredExpenses, loadingIgnored,
        loadUnsortedExpenses, loadSortedHistory, loadIgnoredExpenses,
        refreshExpenseSortingData,
    };
}